export const CALENDAR_GET_NEW_REPORT = 'Get new credit reports earlier';
export const OVERVIEW_RING_UPDATE_SCORE = 'Update Score';
export const OVERVIEW_FACTOR_UPDATE = 'UPDATE';
export const CREDIT_REPORT_PURCHASE_3B_REPORT = 'Purchase 3B Report';
